import {VortexDirectionProvider} from '../../core/vortex_direction_provider.js';
import {createKilnPlugin} from '../utils.js';

export const directionProvider = createKilnPlugin(() => ({
  render: (root, host) => (
    <VortexDirectionProvider element={host}>{root}</VortexDirectionProvider>
  ),
}));
